import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CableIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cable"}/>
}
